<template>
  <div class="profile-container container">
    <div class="profile-portrait">
      <div class="profile-portrait-container">
      <figure>
        <img src="../../assets/images/LabeebaMiah.jpg" alt="Labeeba Miah">
          </figure>
         <div class="finger-print"><img src="@/assets/images/fingerprints/fingerprint-ten.svg" alt=""></div>
      </div>
    </div>
    <div class="profile-statement">

      <h2>Labeeba Miah</h2>
      <p class="job-title">Student</p>

      <p class="profile-statement-interviewer">Tell us a little bit about yourself </p>

      <p>Hello, my name is Labeeba. I'm 22 years old and a final year Philosophy student at Man Met. I really enjoy Ancient Greek Philosophy as well as Eastern Philosophy through my own research. Through the university, I’m a part of the British Asian Society, which has really helped me find a home at university. Outside of my studies I enjoy listening to all types of music, and I love editing pictures and videos. In addition to this, I adore fashion as it allows me to express myself. I also love socialising through exploring new locations and interests, such as cuisines from different cultures.</p>

      <p class="profile-statement-interviewer">Why Man Met University?</p>

      <p>I initially chose to attend Man Met as it was most ideal for me (only being a 20-minute drive away). However, after attending Man Met for 4 years now, I can wholeheartedly say that it has been one of the best experiences I’ve had in my life. The university has not only helped me grow academically and career wise, but it has helped me develop and blossom into a confident woman.</p>

      <p class="profile-statement-interviewer">What is something that you love about your culture or heritage? </p>

      <p>My country was founded on the principal idea of freedom and it's something I carry with me wherever I go. Bangladesh is a relatively young country (being only 51 years old), but it fought with great courage for its independence, and, for this reason, I have something to be proud of everyday.</p>

      <p class="profile-statement-interviewer">What does it look like to bring your whole self to your education? </p>

      <p>To bring my whole self to my education looks like holding nothing back and being my most authentic self. This means not being afraid to ask questions when I don’t understand something and raising concerns, if there are any.</p>

      <p class="profile-statement-interviewer">How do you think MMU can best celebrate their Black, Asian, and Ethnic Minority staff and students? </p>

      <p>Man Met can better celebrate their BAME staff and students by emphasising the importance of their representation. Representation is especially important, and this is what is currently lacking at the university. If young BAME students, especially those interested in Liberal Arts subjects, are shown others who are either students or tutors of said subjects, they are more likely to pursue those subjects.</p>

      <p class="profile-statement-interviewer">What are you most proud of?</p>

      <p>I am most proud of the academic I have become, and not just for myself - I’m proud of the progress I have made for other young BAME women who are interested in the Humanities. I am also striving to bring more BAME academics, more voices and more representation along with me.</p>

    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

  // .profile-container {
  // flex-direction: row-reverse;
  // }

  .profile-portrait-container {
    justify-content: flex-start;
  }

</style>